import { render, staticRenderFns } from "./addAutoTemplate.vue?vue&type=template&id=58037eae&scoped=true&"
import script from "./addAutoTemplate.vue?vue&type=script&lang=js&"
export * from "./addAutoTemplate.vue?vue&type=script&lang=js&"
import style0 from "./addAutoTemplate.vue?vue&type=style&index=0&id=58037eae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58037eae",
  null
  
)

export default component.exports